// extracted by mini-css-extract-plugin
export default {"orderGroupHeader":"rW7CqF6wC2oxAFKfyXoS"};